import Editor from "@toast-ui/editor"
import "@toast-ui/editor/dist/toastui-editor.css";

$(() => {
    $(".markdown-editor").each(function (index, markdownEditorComponent) {
        const obj = $(markdownEditorComponent);
        let textarea = obj.children("textarea");

        if (undefined === textarea[0]) {
            console.error("Markdown editor component has to contain a fallback textarea");
        }

        textarea = textarea.clone();
        textarea.insertAfter(obj);

        const editor = new Editor({
            el: markdownEditorComponent,
            height: "400px",
            initialEditType: "wysiwyg",
            hideModeSwitch: true,
            usageStatistics: false,
            toolbarItems: [
                ["heading", "bold", "italic", "strike"],
                ["hr", "quote"],
                ["ul", "ol", "indent", "outdent"],
                ["link"],
            ],
            initialValue: textarea.val()
        });

        textarea.hide();
        editor.on("change", (e) => {
            textarea.val(editor.getMarkdown());
        });
    });
});
